
import { Rule } from "@/lib/types";
import { SortableRuleList } from "./SortableRuleList";
import { RuleItem } from "./RuleItem";
import { EmptyRuleState } from "./EmptyRuleState";
import { Skeleton } from "@/components/ui/skeleton";
import { useIsMobile } from "@/hooks/use-mobile";

interface RulesListProps {
  rules: Rule[];
  isLoading: boolean;
  selectedMailboxId: string | null;
  tenantId: string;
  onEdit: (rule: Rule) => void;
  onDelete: (rule: Rule) => void;
  onAddClick: () => void;
  onReorder: (updatedRules: Rule[]) => void;
}

export function RulesList({
  rules,
  isLoading,
  selectedMailboxId,
  tenantId,
  onEdit,
  onDelete,
  onAddClick,
  onReorder
}: RulesListProps) {
  const isMobile = useIsMobile();

  if (isLoading) {
    return (
      <div className="space-y-4">
        <Skeleton className="h-8 w-full" />
        {[1, 2, 3].map((i) => (
          <Skeleton key={i} className="h-16 w-full" />
        ))}
      </div>
    );
  }

  if (!selectedMailboxId) {
    return (
      <div className="p-8 text-center text-muted-foreground">
        <p>Please select a mailbox to view its rules</p>
      </div>
    );
  }

  if (rules.length === 0) {
    return <EmptyRuleState onAddClick={onAddClick} />;
  }

  if (isMobile) {
    return (
      <div className="space-y-4">
        {rules.map((rule) => (
          <div key={rule.id} className="border rounded-md p-4">
            <RuleItem
              rule={rule}
              onEdit={onEdit}
              onDelete={onDelete}
            />
          </div>
        ))}
      </div>
    );
  }

  return (
    <SortableRuleList 
      rules={rules} 
      onEdit={onEdit} 
      onDelete={onDelete}
      tenantId={tenantId}
      onReorder={onReorder}
    />
  );
}
